import { styled, useTheme } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../common/hooks';
import { Banner } from '../Banner/Banner';

interface Props {
    i18nKey?: string;
}

const StyledBanner = styled('div')(({ theme }) => ({
    paddingBlock: theme.spacing(1)
}));

export const PdfDownloadErrorBanner = ({ i18nKey = 'PDF_DOWNLOAD_FAILED_SINGLE_CONTACT_US' }: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const supportEmail = useAppSelector(
        (state) => state.global?.globalConfig?.supportEmail || t('APPLICATION_SUPPORT_EMAIL')
    );

    return (
        <StyledBanner>
            <Banner
                type="error"
                messageNode={
                    <Trans
                        i18nKey={i18nKey}
                        components={{
                            cta: (
                                <a
                                    href={`mailto:${supportEmail}`}
                                    style={{
                                        color: theme.palette.semantic.int.selected,
                                        textDecoration: 'underline',
                                        textUnderlineOffset: '2px',
                                        fontWeight: 600,
                                        cursor: 'pointer'
                                    }}
                                />
                            )
                        }}
                    />
                }
            />
        </StyledBanner>
    );
};
